export const LanguageType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const

export type LanguageTypeType = typeof LanguageType[keyof typeof LanguageType]

export default LanguageType
